import React from 'react';
import { Text, View, Pressable, Animated } from 'react-native';
import { useTheme } from '@themeProvider';
import { useLanguage } from '@languageProvider';
import { Commons, Spacing, Typography, Mixins, Colors } from '@styles';
import { useModal } from '@lib';
import { AddDelivery } from '@modals';
import {  Switch } from '@atoms';

const _DeliveryWidget = ({ setDelivery, delivery }) => {
    const { translate } = useLanguage();
    const { pushActionSheet } = useModal();
    const { useColor } = useTheme();
    const [backgroundColor, primaryColor, body] = useColor([
        'background',
        'primary',
        'body'
    ])

    const showDeliveryModal = async () => {
        if (!delivery) {
            pushActionSheet({
                children: (value, setValue) => <AddDelivery {...{ value, setValue }} />,
                actions: [{
                    displayText: translate('addDelivery'),
                    type: 'x-focus',
                    function: (value) => {
                        setDelivery(value)
                        return true;
                    }
                }],
                initialState: ''
            })
        } else {
            pushAlert({
                title: translate('removeDelivery'),
                text: translate('removeDeliveryExplanation', { delivery }),
                actions: [{
                    function: () => {
                        setDelivery();
                        return true;
                    },
                    displayText: translate('remove'),
                    type: 'destructive'
                }]
            })
        }
    }

    return (
        <Pressable style={[{ marginHorizontal: Spacing.MARGINS }]} onPress={showDeliveryModal}>
            {delivery ?
                <View style={[Mixins.rounding(24), { backgroundColor: Colors.setOpacity(primaryColor, .1), marginTop: Spacing.S }]}>
                    <Text style={[Typography.OVERLINE, { marginTop: Spacing.XS, color: primaryColor, textAlign: 'center' }]}>{translate('modify')}</Text>
                    <Text style={{ textAlign: 'center', marginBottom: Spacing.XS, flexGrow: 1 }}>
                        <Text style={[Typography.SUBTITLE, { color: body }]}>{translate('deliverTo')}: </Text>
                        <Text style={[Typography.H6, { color: primaryColor }]}>{delivery}</Text>
                    </Text>
                </View> :
                <View style={{ marginVertical: Spacing.S }}>
                    <Text style={[Typography.SUBTITLE, { color: body, textAlign: 'center' }]}>{translate('dontWannaMove?')}</Text>
                    <Text style={[Typography.TITLE, { color: primaryColor, textAlign: 'center' }]}>{translate('deliverToMyPlace')}</Text>
                </View>
            }
        </Pressable>
    )
}

export const DeliveryWidget = ({ delivery, setDelivery }) => {
    const { translate } = useLanguage();

    const onPress = () => {
        setDelivery(!delivery);
    }

    return (<View style={{ paddingVertical: Spacing.M, alignItems: 'center' }}>
        <Switch label={translate('bringItToVipZone')} checked={!!delivery} onPress={onPress} />
    </View>)
}
